import { defineMessages } from 'react-intl';

const messages = defineMessages({
  monthlyLeaseChargesOrCreditsLabel: {
    id: 'App.LeaseDataTabForm.MonthlyLeaseChargesOrCredits.monthlyLeaseChargesOrCreditsLabel',
    defaultMessage: 'Monthly Lease Charges or Credits',
  },
  addMonthlyTransactionLabel: {
    id: 'App.LeaseDataTabForm.MonthlyLeaseChargesOrCredits.addMonthlyTransactionLabel',
    defaultMessage: 'Add Monthly Transaction',
  },
  leaseStartDateRequired: {
    id: 'App.LeaseDataTabForm.MonthlyLeaseChargesOrCredits.leaseStartDateRequired',
    defaultMessage: 'Must Enter all required fields',
  },
  totalMonthlyDue: {
    id: 'App.LeaseDataTabForm.MonthlyLeaseChargesOrCredits.totalMonthlyDue',
    defaultMessage: `{note} "Section E - Total Monthly Due" on Lease will pull from the Monthly Recurring Charges on the
      View Unit Screen.  If these amounts are incorrect, contact your system administrator.`,
  },
  noteGeneratingLease: {
    id: 'App.LeaseDataTabForm.MonthlyLeaseChargesOrCredits.noteGeneratingLease',
    defaultMessage: 'NOTE ON GENERATING LEASE:',
  },
  moveOutProrateTooltip: {
    id: 'App.LeaseDataTabForm.MonthlyLeaseChargesOrCredits.moveOutProrateTooltip',
    defaultMessage:
      // eslint-disable-next-line max-len
      "This transaction cannot be edited or removed as it was auto-generated due to the 'Prorate Move-Outs at Start of Month' setting. The system calculates the anticipated balance based on the scheduled move-out date and will automatically reconcile the ledger if any changes are made to the move-out schedule. No manual adjustments are needed.",
  },
  automatedTransactionTooltip: {
    id: 'App.LeaseDataTabForm.MonthlyLeaseChargesOrCredits.automatedTransactionTooltip',
    defaultMessage:
      'This transaction is system-generated and cannot be edited or removed.',
  },
  automatedTransactionCodesTooltip: {
    id: 'App.LeaseDataTabForm.MonthlyLeaseChargesOrCredits.automatedTransactionCodesTooltip',
    defaultMessage:
      // eslint-disable-next-line max-len
      'Any transaction codes that appear disabled are automatically created whenever a lease is executed, rent is changed, or a certification requires them. No manual entry is needed.',
  },
});

export default messages;
